import React from 'react';

interface TableNoDataIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const TableNoDataIcon: React.FC<TableNoDataIconProps> = ({ 
  width = 100, 
  height = 100, 
  className = "" 
}) => {
  return (
    <div className={`table-no-data-icon ${className}`}>
      <svg 
        width={width} 
        height={height} 
        viewBox="0 0 100 100" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="50" cy="50" r="40" stroke="#e5e7eb" strokeWidth="2" fill="none"/>
        <path d="M30 50h40M50 30v40" stroke="#e5e7eb" strokeWidth="2"/>
        <text x="50" y="75" textAnchor="middle" fill="#9ca3af" fontSize="12">
          ไม่มีข้อมูล
        </text>
      </svg>
    </div>
  );
};

export default TableNoDataIcon;
